<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <v-row>
      <v-col>
        <VTextField
          v-model="data.name[selectedLang]"
          :label="$t('forms.labels.name')"
          :rules="{ required: selectedLang === teamMainLang, min: 1, max: 200 }"
          :disabled="!isEditable"
          data-cy="frequencyForm-name"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <VTextField
          ref="frequency-occurenceAmount"
          v-model="data.occurenceAmount"
          type="number"
          :label="$t('forms.labels.occurenceAmount')"
          :disabled="!isEditable"
          data-cy="frequencyForm-occurenceAmount"

          @input="updateData"
        />
      </v-col>
      <v-col>
        <VSelect
          ref="frequency-timeUnit"
          v-model="data.timeUnit"
          :label="$t('forms.labels.timeUnit')"
          itemValue="key"
          :items="timeUnits"
          :disabled="!isEditable"
          data-cy="FrequencySelect"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirtyChanged', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';

export default {
    components: {
        ValidationObserver,
        VTextField,
        VSelect,
        SlotScopeWatcher,
    },
    props: {
        frequency: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
        isEditable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            data: {
                name: {},
                occurenceAmount: null,
                timeUnit: null,
            },
        };
    },
    computed: {
        ...mapGetters([
            'teamMainLang',
            'selectedLang',
        ]),

        timeUnits() {
            return [
                {
                    name: this.$t('forms.labels.day'),
                    key: 'day',
                },
                {
                    name: this.$t('forms.labels.week'),
                    key: 'week',
                },
                {
                    name: this.$t('forms.labels.month'),
                    key: 'month',
                },
                {
                    name: this.$t('forms.labels.year'),
                    key: 'year',
                },
                {
                    name: this.$t('forms.labels.asNeeded'),
                    key: 'asNeeded',
                },
            ];
        },
    },
    watch: {
        populateWith: {
            handler() {
                if (this.isEdition) {
                    this.data = this.frequency;
                }
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};
</script>
